import { z } from 'zod';
import { fromZodError } from 'zod-validation-error';

export function getErrorMessage(error: unknown): string {
  if (error instanceof z.ZodError) {
    return fromZodError(error).message;
  }

  if (error instanceof Error) {
    return error.message;
  }

  const httpError = intoHttpError(error);
  if (httpError) {
    switch (httpError.code) {
      case '403':
        return 'Access denied';
    }

    return httpError.message;
  }

  console.error('Unable to get error message for error', error);
  return 'Unknown Error';
}

type HttpError = {
  code: string;
  message: string;
  details?: string;
};

function intoHttpError(error: unknown): HttpError | undefined {
  if (
    error &&
    typeof error === 'object' &&
    'code' in error &&
    typeof error.code === 'string' &&
    'message' in error &&
    typeof error.message === 'string'
  ) {
    let httpError: HttpError = {
      code: error.code,
      message: error.message,
    };

    if ('details' in error && typeof error.details === 'string') {
      httpError = {
        ...httpError,
        details: error.details,
      };
    }

    return httpError;
  }

  return undefined;
}
